import React, { useState, Component } from 'react';
import Heading from '../Atoms/Heading.js';
// import { Link } from 'react-router-dom';
// import { client } from '../../client';


class NewsTextBox extends Component {
  // use a constructor if necessary
  constructor(props) {
    super(props);
   
    this.state = {
      isHovered: false
    };

    // This binding is necessary to make `this` work in the callback
    this.handleHover = this.handleHover.bind(this);
  }

  handleHover = () => this.setState({ isHovered: !this.state.isHovered });
  

  render() {

    const {cx, title, excerpt, date, hoverType} = this.props;


    return (
      <div className={`flex  justify-between ${cx}`} >
        <div className={`hover-animation flex wrap pl-m h-9 pr-s pt-s w-100 large-h-5 ${this.state.isHovered ? hoverType : ""} `} onMouseEnter={this.handleHover} onMouseLeave={this.handleHover}>
          <div className="">
            <h2 className="w-100" >{`${title}`}</h2>
            <p className="w-100" >{excerpt}</p>
          </div>
          <div className="flex items-bottom pb-s w-100">
            <small>📍 {date?.substring(0,10)}</small>
          </div>
        </div>
      </div>
    );
  }
}


export default NewsTextBox;